import { render, staticRenderFns } from "./editFeedback.vue?vue&type=template&id=428d3ba5&scoped=true"
import script from "./editFeedback.vue?vue&type=script&lang=js"
export * from "./editFeedback.vue?vue&type=script&lang=js"
import style0 from "./editFeedback.vue?vue&type=style&index=0&id=428d3ba5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428d3ba5",
  null
  
)

export default component.exports